import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import useAuthStore from '@/store/useAuthStore'
import { toast } from 'sonner'
import api from '@/lib/api'

export default function AuthCallback() {
  const navigate  = useNavigate()
  const setAuth   = useAuthStore(s => s.setAuth)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token  = params.get('token')
    const error  = params.get('error')

    if (error) {
      toast.error('Google login failed. Please try again.')
      navigate('/login')
      return
    }

    if (!token) {
      toast.error('Something went wrong. Please try again.')
      navigate('/login')
      return
    }

    // Token se user info fetch karo
    const fetchUser = async () => {
      try {
        const { data } = await api.get('/auth/me', {
          headers: { Authorization: `Bearer ${token}` }
        })

        setAuth(data.user, token)
        toast.success(`Welcome, ${data.user.businessName || 'User'}! 👋`)
        navigate('/app/dashboard')
      } catch {
        toast.error('Login failed. Please try again.')
        navigate('/login')
      }
    }

    fetchUser()
  }, [navigate, setAuth])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-white">
      <Loader2 className="w-10 h-10 text-emerald-500 animate-spin" />
      <p className="text-gray-500 text-sm">Signing you in with Google…</p>
    </div>
  )
}
